import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { INSTAGRAM_URL, INSTAGRAM_HANDLE } from "../lib/scroll";

const TILES = [
  { src: "/photos/cheesecake-plate.jpg", alt: "Single Basque burnt cheesecake cup" },
  { src: "/photos/cheesecake-cups.jpg", alt: "Oreo and berry flavoured Basque cheesecake cups" },
  { src: "/photos/cooling-racks.jpg", alt: "Cookies and brownies cooling on racks" },
  { src: "/photos/cookies.jpg", alt: "Chunky choco-chip cookies" },
];

export default function InstaFeed() {
  return (
    <section id="insta" className="scroll-mt-24 py-24 sm:py-32">
      <div className="max-w-[1440px] mx-auto px-5 sm:px-10">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.8 }}
          className="flex flex-col sm:flex-row sm:items-end justify-between gap-6 mb-12 sm:mb-16"
        >
          <div>
            <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.3em] text-rust mb-4">
              Fresh from the feed
            </p>
            <h2 className="font-display font-bold text-4xl sm:text-5xl tracking-tight leading-[1.02]">
              Bakes, straight <span className="italic text-rust">from the oven.</span>
            </h2>
          </div>
          <a
            href={INSTAGRAM_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="insta-follow-button"
            className="inline-flex items-center gap-2.5 bg-ink text-eggshell px-6 py-3.5 rounded-full font-mono text-[11px] uppercase tracking-[0.2em] hover:bg-rust transition-colors duration-300 self-start sm:self-auto"
          >
            <Instagram size={15} /> Follow {INSTAGRAM_HANDLE}
          </a>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6">
          {TILES.map((t, i) => (
            <motion.a
              key={t.src}
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`insta-feed-tile-${i + 1}`}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.7, delay: i * 0.09 }}
              className="group relative overflow-hidden rounded-[18px] border-[3px] border-ink aspect-square"
              aria-label={`View ${INSTAGRAM_HANDLE} on Instagram`}
            >
              <img
                src={t.src}
                alt={t.alt}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-[1.1s] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.07]"
              />
              <span className="absolute inset-0 bg-ink/0 group-hover:bg-ink/35 transition-colors duration-300 flex items-center justify-center">
                <Instagram
                  size={28}
                  className="text-eggshell opacity-0 group-hover:opacity-100 scale-75 group-hover:scale-100 transition-all duration-300"
                />
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
